import { useQuery } from '@tanstack/react-query';
import { CreditHistoryQueryParams, creditService } from '@/services/creditService';
import { CreditHistory } from '@/types/model';
import { PaginatedResponse, QueryParams } from '@/services/apiClient';

export const creditHistoryKeys = {
  all: ['creditHistory'] as const,
  lists: () => [...creditHistoryKeys.all, 'list'] as const,
  list: (params: QueryParams) => [...creditHistoryKeys.lists(), params] as const,
};

export const useCreditHistoryData = (params: QueryParams = {}) => {
  const queryResult = useQuery({
    queryKey: creditHistoryKeys.list(params),
    queryFn: () => creditService.getAllCreditHistory(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    data: queryResult.data,
    isLoading: queryResult.isLoading,
    isError: queryResult.isError,
    error: queryResult.error,
    refetch: queryResult.refetch,
  };
};

export const useCreditHistoryForUser = (username: string, params: QueryParams = {}) => {
  return useQuery<PaginatedResponse<CreditHistory>, Error>({
    queryKey: ['creditHistory', username, params],
    queryFn: () => creditService.getCreditHistory(username, params),
  });
};

export const useCreditSalesReport = (params: CreditHistoryQueryParams = {}, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['creditHistory', 'sales-report', params],
    queryFn: () => creditService.getCreditSalesReport(params),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
};
